import React from "react";
import { Link } from "react-router-dom";
import Himg1 from "../../images/slider/1.webp";
import Himg2 from "../../images/slider/2.webp";
import Himg3 from "../../images/slider/3.webp";
import Himg4 from "../../images/slider/4.webp";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const hero = ({ onCount }) => {
  return (
    <section className="hero_section">
      <div className="bg_shape">
        <svg viewBox="0 0 1920 1220" preserveAspectRatio="none">
          <path
            d="M0 0H1920V1000C1920 1000 1632 619 962 917C292 1215 0 1000 0 1000V0Z"
            fill="#EBF7FF"
          />
        </svg>
      </div>
      <div className="content">
        <h2>
            Where comfort meets functionality
        </h2>
        <h3>
            Treatment Beds, Stools, Autoclaves & Lights
        </h3>
        <p>
          SKIEN is trusted by professionals in the beauty, wellness, and medical industries to supply premium electric treatment beds, dental stools and saddle chairs, autoclaves, and examination lights.
        </p>
        <Link onClick={ClickHandler} className="theme-btn light" to="/contact">
          Request a Consultation
        </Link>
      </div>
      <div className="image_content">
        <div className="image">
          <img
            src={Himg3}
            srcSet={`
             ${Himg1} 480w,
             ${Himg2} 768w,
             ${Himg3} 1024w,
             ${Himg4} 1600w
            `}
            sizes="(max-width: 600px) 480px,
           (max-width: 900px) 768px,
           (max-width: 1200px) 1024px,
           1600px"
            alt="SKIEN provides you with equipment"
            fetchpriority="high"
          />
        </div>
      </div>
    </section>
  );
};

export default hero;
